import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import moment from "moment";
import usePostAnalytics from "@usePostAnalytics";

// constants
import {
  convertDateIntoUTCForTimezone,
  convertUTCIntoDateForTimezone,
  DATE_TIME_SECOND_FORMAT,
  DATE_FORMAT,
} from "@datehandle";
import LocaleStrings from "@language";
import { ALLOWED_LAYOUTS } from "@constant";

// files
import { TicketIcon as TicketIconOutline } from "@heroicons/react/24/outline";

const MainContainer = (props) => {
  const location = useLocation();
  let { routes, hideHeaderFooter, eventData, session } = props;
  const postAffiliationAnalytics = usePostAnalytics(session);
  const [allowForOthers, setAllowForOthers] = useState(false);

  useEffect(() => {
    let path = location?.pathname;
    let check = path.search("tickets") === -1 && path.search("register") === -1;
    setAllowForOthers(check);
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === ALLOWED_LAYOUTS.admin) {
        // console.log(prop);
        return <Route path={prop.path} element={prop.component} key={key} />;
      } else {
        return null;
      }
    });
  };

  let allowRegistration = false;
  let registrationStarted = true;
  if (allowForOthers) {
    allowRegistration = true;
  } else {
    // Check Event Policy
    if (
      eventData?.eventsettings_by_eventid?.[0]?.eventpolicytype !==
      "no_registration"
    ) {
      allowRegistration = true;
    }

    // Check Event Registration Date
    if (eventData?.eventsettings_by_eventid?.[0]?.reg_login_dates) {
      let explodeDate = JSON.parse(
        eventData.eventsettings_by_eventid[0].reg_login_dates
      );
      // console.log("explodeDate :- ", explodeDate);
      // console.log("eventtimezone :- ", eventData?.eventtimezone);
      if (
        explodeDate?.registrationdates?.startdate &&
        explodeDate?.registrationdates?.enddate
      ) {
        // Locale timezone
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Get local timezone time in utc
        var todayUTC = convertDateIntoUTCForTimezone(
          moment().format(DATE_TIME_SECOND_FORMAT),
          tz
        ).format(DATE_TIME_SECOND_FORMAT);
        // console.log("utc time :- ", todayUTC);
        // Get event timezone current time
        let today = convertUTCIntoDateForTimezone(
          todayUTC,
          eventData?.eventtimezone
        ).format(DATE_FORMAT);
        // console.log("today :- ", today);

        let startTime = explodeDate.registrationdates.startdate;
        // console.log("startTime :- ", startTime);

        let endTime = explodeDate.registrationdates.enddate;
        // console.log("endTime :- ", endTime);

        var validDate =
          moment(startTime).isSameOrBefore(today, "days") &&
          moment(endTime).isSameOrAfter(today, "days");

        // console.log("validDate :- ", validDate);
        if (!validDate) {
          allowRegistration = false;
          registrationStarted = false;
        }
      }
    }
  }

  return (
    <main
      id="MAIN_CONTAINER"
      className={`main-container px-4 lg:px-6 xl:px-0 ${
        hideHeaderFooter ? "" : "-mt-16"
      }`}
    >
      <div className="min-h-inherit h-full bg-white rounded-lg custom-border mx-auto max-w-5xl">
        {allowRegistration ? (
          <Routes>{getRoutes(routes)}</Routes>
        ) : (
          <div className="content-body flex items-center justify-center flex-col space-y-2">
            <TicketIconOutline className="text-secondary w-20 h-20" />

            <div className="no-content-text">
              {registrationStarted
                ? LocaleStrings.kRegistrationNotAvailableText
                : LocaleStrings.kRegistrationNotAvailableText}
            </div>
          </div>
        )}
      </div>
      <div id="scrollTrackerEnd" />
    </main>
  );
};

const mapStateToProps = (state) => {
  return { session: state.session, eventData: state.eventData };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);
